<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="border border-gray-200 -m-px">
    <div
      @click.self="handleSelected"
      :style="indent"
      class="flex items-center space-x-2 cursor-pointer px-4 py-4 hover:bg-gray-50"
    >
      <div
        class="p-1.5 rounded-full"
        :class="{ 'hover:bg-gray-100': children.length > 0 }"
        @click="toggleChildren"
      >
        <div class="h-5 w-5">
          <div v-if="children.length > 0">
            <ChevronDownIcon
              v-if="expanded"
              class="text-gray-900"
              aria-hidden="true"
            />
            <ChevronRightIcon v-else class="text-gray-900" aria-hidden="true" />
          </div>
        </div>
      </div>
      <span class="pointer-events-none select-none text-sm font-medium grow">{{
        name
      }}</span>
    </div>
    <tree-node
      v-if="expanded"
      v-for="child in children"
      :children="child.children"
      :id="child.id"
      :name="child.name"
      :key="child.id"
      :depth="depth + 1"
      :handle-clicked="handleClicked"
    >
    </tree-node>
  </div>
</template>
<script setup>
import { computed, defineProps, onMounted, ref, watch } from "vue";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/vue/20/solid";
import { usePage } from "@inertiajs/vue3";

const props = defineProps({
  id: String,
  name: String,
  children: Object,
  depth: Number,
  handleClicked: Function,
});

const tenant = usePage().props.tenant;
const userId = usePage().props.auth.id;

const expanded = ref(false);

const indent = computed(() => {
  if (props.depth === 0) {
    return { paddingLeft: "1rem" };
  }

  return { paddingLeft: `${props.depth * 1 + 1}rem` };
});

function handleSelected() {
  props.handleClicked(props.id);
}

function toggleChildren() {
  expanded.value = !expanded.value;
}

onMounted(() => {
  expanded.value =
    localStorage.getItem(
      `user-${userId}-tenant-${tenant.id}-user-tree-node-${props.id}`
    ) === "true";
});

watch(expanded, () => {
  localStorage.setItem(
    `user-${userId}-tenant-${tenant.id}-user-tree-node-${props.id}`,
    expanded.value.toString()
  );
});
</script>
